import { Slide } from "react-reveal";

const EcommerceSolutionsOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    Every online store is designed around your business model -
                    ensuring higher conversions, seamless payments and the
                    flexibility to scale as your sales grow.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Online Store Strategy & Architecture</h3>
                      <ul>
                        <li>
                          <span>
                            Business model alignment(B2C, B2B, Hybrid)
                          </span>
                        </li>
                        <li>
                          <span>Store structure & product categories</span>
                        </li>
                        <li>
                          <span>Product hierarchy & navigation design</span>
                        </li>
                        <li>
                          <span>Conversion focused user journey</span>
                        </li>
                        <li>
                          <span>Checkout flow optimization</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Online Store Interface & Experience Design</h3>
                      <ul>
                        <li>
                          <span>Mobile-first, responsive design</span>
                        </li>
                        <li>
                          <span>High-performance product & category pages</span>
                        </li>
                        <li>
                          <span>Smart search & filtering systems</span>
                        </li>
                        <li>
                          <span>Products SEO friendly structure</span>
                        </li>
                        <li>
                          <span>Purchase triggers and psychology</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Inventory management</h3>
                      <ul>
                        <li>
                          <span>Product creation & catalog management</span>
                        </li>
                        <li>
                          <span>
                            Product variations (size, color, type, etc)
                          </span>
                        </li>
                        <li>
                          <span>Inventory tracking & stock alerts</span>
                        </li>
                        <li>
                          <span>
                            Pricing management (discounts, offers, tiers)
                          </span>
                        </li>
                        <li>
                          <span>Digital & physical product support</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Shopping Cart & Checkout System</h3>
                      <ul>
                        <li>
                          <span>Optimized cart experience</span>
                        </li>
                        <li>
                          <span>One page/multi-step checkout options</span>
                        </li>
                        <li>
                          <span>Guest & account based checkout</span>
                        </li>
                        <li>
                          <span>Abandoned cart recovery systems</span>
                        </li>
                        <li>
                          <span>Coupon & discount code systems</span>
                        </li>
                        <li>
                          <span>Subscription & recurring billings</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Payments & Transactions Systems</h3>
                      <ul>
                        <li>
                          <span>Mobile money integration</span>
                        </li>
                        <li>
                          <span>Whatsapp checkout</span>
                        </li>
                        <li>
                          <span>Card payments (Visa, Mastercard, etc)</span>
                        </li>
                        <li>
                          <span>POS & in-field payment integrations</span>
                        </li>
                        <li>
                          <span>Multi-currency support</span>
                        </li>
                        <li>
                          <span>Secure payment processing & validation</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Order Management & Fulfillment System</h3>
                      <ul>
                        <li>
                          <span>Centralized orders dashboard</span>
                        </li>
                        <li>
                          <span>Order tracking & status updates</span>
                        </li>
                        <li>
                          <span>Invoice & receipt generation</span>
                        </li>
                        <li>
                          <span>Delivery & shipping management</span>
                        </li>
                        <li>
                          <span>Returns & refund handling systems</span>
                        </li>
                        <li>
                          <span>Multi-vendor marketplace functionality</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Customer Management & Engagement</h3>
                      <ul>
                        <li>
                          <span>Customer profiles & accounts</span>
                        </li>
                        <li>
                          <span>Order history & tracking</span>
                        </li>
                        <li>
                          <span>Wishlist & saved carts</span>
                        </li>
                        <li>
                          <span>Email, SMS & Notification systems</span>
                        </li>
                        <li>
                          <span>Reviews, ratings & feedback systems</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Marketing, Sales & Conversion Tools</h3>
                      <ul>
                        <li>
                          <span>SEO-rich product & category pages</span>
                        </li>
                        <li>
                          <span>Conversion tracking setup</span>
                        </li>
                        <li>
                          <span>Promotional tools (discounts, rewards programs)</span>
                        </li>
                        <li>
                          <span>Email marketing integrations</span>
                        </li>
                        <li>
                          <span>Upselling & cross-selling features</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Analytics & Business Intelligence</h3>
                      <ul>
                        <li>
                          <span>Sales dashboards & reports</span>
                        </li>
                        <li>
                          <span>Customer behaviour tracking</span>
                        </li>
                        <li>
                          <span>Product performance insights</span>
                        </li>
                        <li>
                          <span>Revenue analytics</span>
                        </li>
                        <li>
                          <span>Google analytics & tracking integrations</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Performance, Security & Reliability</h3>
                      <ul>
                        <li>
                          <span>High-speed performance optimization</span>
                        </li>
                        <li>
                          <span>SSL security & secure checkout</span>
                        </li>
                        <li>
                          <span>Data protection & encryption</span>
                        </li>
                        <li>
                          <span>System stability under high traffic</span>
                        </li>
                        <li>
                          <span>Backup & recovery systems</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Deployment, Training & Growth Support</h3>
                      <ul>
                        <li>
                          <span>Online store launch & live deployment</span>
                        </li>
                        <li>
                          <span>Staff/admin training</span>
                        </li>
                        <li>
                          <span>Ongoing support & maintenance</span>
                        </li>
                        <li>
                          <span>Feature updates & improvements</span>
                        </li>
                        <li>
                          <span>Scaling support as business grows</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EcommerceSolutionsOffers;
